(function ($) {
  mppProductGroupV1 = {
    formatter: $('.mpp-product-group-v1')
  };

  Drupal.behaviors.mppProductGroupV1 = {
    get: function (key) {
      return mppProductGroupV1[key];
    },

    set: function (key, val) {
      mppProductGroupV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      // remove bg from first group
      formatter.first().css('background-image', 'none');

      formatter.each(function () {
        var thisFormatter = $(this);

        // draw with L2 cache
        $(document).on('inventory_status_stored', function () {
        // weed out any products that lack 'isOrderable' or 'Coming Soon' skus
          $(page_data['product-input-type'].products).each(function (i, product) {
            if (typeof product.skus !== 'undefined') {
              var isOrderableSku = $(product.skus).filter(function () {
                if (typeof $(document).data(this.SKU_ID) != 'undefined') {
                  return ($(document).data(this.SKU_ID).isOrderable == 1)
                      || ($(document).data(this.SKU_ID).INVENTORY_STATUS == 3)
                        || ($(document).data(this.SKU_ID).INVENTORY_STATUS == 2);
                }
              })[0];
              var isDisplayableSku = $(product.skus).filter(function () {
                var undef;
                var sku = $(document).data(this.SKU_ID);

                return typeof site.features.spp_displayable_status !== 'undefined'
                && (sku !== undef && site.features.spp_displayable_status[sku.INVENTORY_STATUS]);
              })[0];

              if (typeof isOrderableSku == 'undefined' && !isDisplayableSku) {
              // remove product - removed completely so the quickshop positioning remains correct
                $('.mpp-product-v1 div[data-productid="' + product.PRODUCT_ID + '"]').remove();
              } else {
                $('.mpp-product-v1 div[data-productid="' + product.PRODUCT_ID + '"]').addClass('hasValidSku');
              }
            }
          });
          // remove those that lack any skus, let alone any valid ones...
          // $('.mpp-product-v1 div[data-productid]').not('.hasValidSku').remove();

          var items = thisFormatter.find('.product');

          // hover class
          items.hover(function () {
            $(this).addClass('hover');
          }, function () {
            $(this).removeClass('hover');
          });

          // setup rows of 3
          for (var i = 0; i < items.length; i += 3) {
            items.slice(i, i + 3).wrapAll('<div class="row"></div>');
          }
        });
      });
    }
  };
})(jQuery);
